import React, { useCallback, useEffect, useRef, useState } from "react";
import { useFaildReports, useFlashReports, useReports, useUpdateCorrection, useUvidFeFileUpload, useUvidFeFlashReports } from "../../projectManagementQueries";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import {
  Button, Checkbox, Grid, LinearProgress, Paper, TableContainer, TextField, Typography, IconButton,
  Radio,
  Icon,
  Tooltip,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import { useHistory } from "react-router";
import { TravelerModal } from "../../../common/travelerModal";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import moment from "moment";
import { toast } from "react-toastify";
import { HeaderProps, Row, useFilters, useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable } from "react-table";
import FormGroup from "@material-ui/core/FormGroup";
import { Alert, AlertTitle, Pagination } from "@material-ui/lab";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { renderHeader } from "../../../common/util";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import * as Yup from "yup";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Link } from "@material-ui/core";
import { Edit, Label, PublishRounded, UpdateRounded } from "@material-ui/icons";
import CloseIcon from '@material-ui/icons/Close';
import { Link as MuiLink, useTheme } from "@material-ui/core/";
import { constant, set } from "lodash";
import { EditProjectItems } from "../myprojects/EditProjectItems";
import { Field, Form, Formik } from "formik";
import { processErrorOnMutation } from "../../../../util/errorMessaging";
import CustomDialog from "../../../common/CustomDialog";
import { formatDate } from "../../../common/formatDate";
import { getTheme } from "../../../common/getLocalTheme";
import { LSDBCoreTableWithoutDropDown } from "../../../common/LSDBCoreTableWithoutDropDown";
import { useQueryClient } from "react-query";
import { off } from "process";
import { LSDBCoreTableWithCheckBox } from "../../../common/LSDBCoreTableWithCheckBox";
import { debounce } from 'lodash';
import { EditableUvidCell } from "./editableUvidNfeCell";
import { usePostFile } from "../../../common/services/fileServices";



const UvidFeFlash = () => {

  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [selectedByDate, setSelectedByDate] = React.useState(false);
  const [selectedByMonth, setSelectedByMonth] = React.useState(false);
  const [itemsPerPage, setitemsPerPage] = React.useState(100);
  const [pageCount, setPageCount] = React.useState(1);
  const [totalFlash, setTotalFlash] = React.useState(0);
  const queryClient = useQueryClient();
  const [filteredPayload, setfilteredPayload] = React.useState<Row<object>[]>([]);
  const [action, setAction] = React.useState(0);
  // const [type, setType] = React.useState('');
  const [month, setMonth] = React.useState('');
  const [flashReports, setFlashReports] = React.useState([]);

  const [status, setStatus] = React.useState('');
  const [serialNumber, setSerialNumber] = React.useState('');
  const [customer, setcustomer] = React.useState('');
  const [tsdName, setTsdName] = React.useState('');


  const [projectNumber, setprojectNumber] = React.useState('');
  const [workorder, setWorkOrder] = React.useState('');
  const [triggerQuery, setTriggerQuery] = useState(false);
  const [editValue, setEditValue] = React.useState(false);

  const [files, setFiles] = React.useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [uploadResult, setUploadResult] = useState<{
    message: string;
    old_measurements_saved: number;
    measurement_results_updated: number;
    skipped: string[];
  } | null>(null);

  const [editedData, setEditedData] = useState<{ [key: string]: { [key: string]: string } }>({});

  // const handleCellChange = (rowId: string, field: string, value: string) => {
  //   setEditedData(prev => {
  //     const updated = {
  //       ...prev,
  //       [rowId]: {
  //         ...prev[rowId],
  //         [field]: value,
  //       },
  //     };
  //     console.log("Edited data:", updated); // 👈 log updated data
  //     return updated;
  //   });
  // };

  const handleCellChange = useCallback((rowId, field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [field]: value,
      },
    }));
  }, []);


  const { mutateAsync: mutatePostFile } = usePostFile();
  const { mutateAsync: mutate } = useUvidFeFileUpload();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (item: any) => {
    console.log(item)
    fileInputRef.current?.click()
  };


  const {
    data: data,
    error: errorData,
    isLoading: isLoading,
    isError: isErrorData,
  } = useUvidFeFlashReports(month, startDate, endDate, pageCount == 1 ? 0 : (pageCount - 1) * 100, itemsPerPage, customer, projectNumber, workorder, serialNumber, tsdName, action);


  const handleStartDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {

    setStartDate(e.target.value);
    setMonth('');

  };

  const handleEndDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
    setEndDate(e.target.value);
    setMonth('');

  };

  const handleInputChangeSerial = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSerialNumber(event.target.value);
  };


  const handleInputChangeCustomer = (event: React.ChangeEvent<HTMLInputElement>) => {
    setcustomer(event.target.value);
  };

  const handleInputChangeTsdName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTsdName(event.target.value);
  };


  const handleInputChangeProject = (event: React.ChangeEvent<HTMLInputElement>) => {
    setprojectNumber(event.target.value);
  };

  const handleInputChangeWorkOrder = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWorkOrder(event.target.value);
  };

  const handleChangeDate = (e: { target: { value: React.SetStateAction<string>; }; }) => {
    const date = e.target.value;
    setMonth(date);
    setStartDate('');
    setEndDate('');


  };


  const searchData = async () => {

    if (selectedByDate) {

      if (startDate === '' || endDate === '') {
        toast.warning('Please select start and end date')
        return;
      }
    } else if (selectedByMonth) {

      if (month === '') {
        toast.warning('Please select month')
        return;
      }
    }
    setPageCount(1)
    setSerialNumber("")
    setprojectNumber("")
    setcustomer("")
    setWorkOrder("")
    setTsdName("")
    setAction(action + 1)
    // refetch();  
  }

  const { authAxios } = useFetchContext();


  const handleFilePicked = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = event.target.files;

    if (uploadedFiles && uploadedFiles.length > 0) {
      for (let file of uploadedFiles) {
        try {
          const uploaded = await mutatePostFile({ authAxios, file });
          const fileUrl = uploaded.id;
          console.log("Uploaded file ID:", fileUrl);
          const response = await mutate(fileUrl);

          setUploadResult(response);
          setDialogOpen(true);
          setAction(action + 1)
        } catch (error) {
          console.error("File upload failed:", error);
          toast.error("File Upload Failed");
        }
      }
    }
  };


  const getDownloads = async (): Promise<any> => {

    if (data.results.length != 0) {
      const response = await authAxios.get(urls.actionResults.uvid_fe_flash_download(month, startDate, endDate, customer, projectNumber, serialNumber, workorder, tsdName), {
        responseType: 'blob'
      });

      const downloadUrl = URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
      document.body.appendChild(a);
      a.click();
      // if (data.results.length == extractedData.length || extractedData.length > 500) {



      // } else {

      //   const response = await authAxios.get(urls.actionResults.flash_filter_download(extractedData), {
      //     responseType: 'blob'
      //   });
      //   const downloadUrl = URL.createObjectURL(response.data);
      //   let a = document.createElement("a");
      //   a.href = downloadUrl;
      //   a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
      //   document.body.appendChild(a);
      //   a.click();
      // }

    } else {
      toast.warning('No data found to download')

    }

  };


  // const transformedArray = Object.entries(editedData).map(([rowId, rowValues]) => ({
  //   rowId,
  //   ...rowValues,
  // }));


  const defaultColumn = useDefaultColumn();

  // const columns = React.useMemo(
  //   () => [

  //     {
  //       Header: "ID",
  //       id: 'id',
  //       accessor: "id",
  //     },


  //     {
  //       Header: "Customer",
  //       id: "Customer",
  //       accessor: "customer_name",
  //     },
  //     {
  //       Header: "Project Number",
  //       id: "Project Number",
  //       accessor: "project_number",

  //     },
  //     {
  //       Header: "WorkOrder",
  //       id: "WorkOrder",
  //       accessor: "work_order_name",

  //     },
  //     {
  //       Header: "Serial Number",
  //       id: "Serial Number",
  //       accessor: "unit_serial_number",
  //     },

  //     {
  //       Header: "Model Type",
  //       id: "Model Type",
  //       accessor: "module_type_name",
  //     },

  //     {
  //       Header: "Procedure Name",
  //       id: "Procedure Name",
  //       accessor: 'name',

  //     },


  //     {
  //       Header: "Definition",
  //       id: "Definition",
  //       accessor: 'procedure_definition_name',

  //     },


  //     {
  //       Header: "Date Time",
  //       id: "Date Time",
  //       accessor: "date_time",
  //       Cell: ({ cell }: any) => {
  //         return <p>{formatDate(cell.value)}</p>
  //       }
  //     },

  //     {
  //       Header: "PMP",
  //       id: "pmp",
  //       accessor: 'flash_values.Pmp',

  //     },
  //     {
  //       Header: "ISC",
  //       id: "isc",
  //       accessor: 'flash_values.Isc',

  //     },
  //     {
  //       Header: "VOC",
  //       id: "voc",
  //       accessor: 'flash_values.Voc',

  //     },
  //     {
  //       Header: "VMP",
  //       id: "vmp",
  //       accessor: 'flash_values.Vmp',

  //     },
  //     {
  //       Header: "IMP",
  //       id: "imp",
  //       accessor: 'flash_values.Imp',

  //     },



  //     {
  //       Header: "New PMP",
  //       id: "newPmp",
  //       Cell: ({ row }: any) => {
  //         const rowId = row.original.id;
  //         return (
  //           <EditableUvidCell
  //             row={row.original}
  //             field="newPmp"
  //             label="PMP"
  //             value={editedData[rowId]?.newPmp ?? row.original.newPmp ?? ""}
  //             onChange={handleCellChange}
  //           />
  //         );
  //       }
  //     },
  //     {
  //       Header: "New ISC",
  //       id: "newIsc",
  //       Cell: ({ row }: any) => {
  //         const rowId = row.original.id;
  //         return (
  //           <EditableUvidCell
  //             row={row.original}
  //             field="newIsc"
  //             label="ISC"
  //             value={editedData[rowId]?.newIsc ?? row.original.newIsc ?? ""}
  //             onChange={handleCellChange}
  //           />
  //         );
  //       }
  //     },
  //     {
  //       Header: "New POC",
  //       id: "newPoc",
  //       Cell: ({ row }: any) => {
  //         const rowId = row.original.id;
  //         return (
  //           <EditableUvidCell
  //             row={row.original}
  //             field="newPoc"
  //             label="POC"
  //             value={editedData[rowId]?.newPoc ?? row.original.newPoc ?? ""}
  //             onChange={handleCellChange}
  //           />
  //         );
  //       }
  //     },
  //     {
  //       Header: "New VMP",
  //       id: "newVmp",
  //       Cell: ({ row }: any) => {
  //         const rowId = row.original.id;
  //         return (
  //           <EditableUvidCell
  //             row={row.original}
  //             field="newVmp"
  //             label="VMP"
  //             value={editedData[rowId]?.newVmp ?? row.original.newVmp ?? ""}
  //             onChange={handleCellChange}
  //           />
  //         );
  //       }
  //     },
  //     {
  //       Header: "New IMP",
  //       id: "newImp",
  //       Cell: ({ row }: any) => {
  //         const rowId = row.original.id;
  //         return (
  //           <EditableUvidCell
  //             row={row.original}
  //             field="newImp"
  //             label="IMP"
  //             value={editedData[rowId]?.newImp ?? row.original.newImp ?? ""}
  //             onChange={handleCellChange}
  //           />
  //         );
  //       }
  //     },
  //   ],
  //   []
  // );

  const columns = React.useMemo(() => {
    const baseColumns = [
      {
        Header: "ID",
        id: "id",
        accessor: "id",
      },
      {
        Header: "Customer",
        id: "Customer",
        accessor: "customer_name",
      },
      {
        Header: "Project Number",
        id: "Project Number",
        accessor: "project_number",
      },
      {
        Header: "WorkOrder",
        id: "WorkOrder",
        accessor: "work_order_name",
      },
      {
        Header: "Serial Number",
        id: "Serial Number",
        accessor: "unit_serial_number",
      },
      {
        Header: "Model Type",
        id: "Model Type",
        accessor: "module_type_name",
      },
      {
        Header: "Procedure Name",
        id: "Procedure Name",
        accessor: "name",
      },
      {
        Header: "Definition",
        id: "Definition",
        accessor: "procedure_definition_name",
      },
      {
        Header: "TSD",
        id: "TSD",
        accessor: "test_sequence_definition_name",
      },
      {
        Header: "Date Time",
        id: "Date Time",
        accessor: "date_time",
        Cell: ({ cell }: any) => <p>{formatDate(cell.value)}</p>,
      },
      {
        Header: "PMP",
        id: "pmp",
        accessor: "flash_values.Pmp",
      },
      {
        Header: "ISC",
        id: "isc",
        accessor: "flash_values.Isc",
      },
      {
        Header: "VOC",
        id: "voc",
        accessor: "flash_values.Voc",
      },
      {
        Header: "VMP",
        id: "vmp",
        accessor: "flash_values.Vmp",
      },
      {
        Header: "IMP",
        id: "imp",
        accessor: "flash_values.Imp",
      },
    ];

    const editableColumns = editValue
      ? [
        {
          Header: "New PMP",
          id: "newPmp",
          Cell: ({ row }: any) => {
            const rowId = row.original.id;

            return (
              <EditableUvidCell
                row={row.original}
                field="newPmp"
                label="PMP"
                value={editedData[rowId]?.newPmp ?? row.original.newPmp ?? ""}
                onChange={handleCellChange}

              />
            );
          },
        },
        {
          Header: "New ISC",
          id: "newIsc",
          Cell: ({ row }: any) => {
            const rowId = row.original.id;

            return (
              <EditableUvidCell
                row={row.original}
                field="newIsc"
                label="ISC"
                value={editedData[rowId]?.newIsc ?? row.original.newIsc ?? ""}
                onChange={handleCellChange}

              />
            );
          },
        },
        {
          Header: "New POC",
          id: "newPoc",
          Cell: ({ row }: any) => {
            const rowId = row.original.id;

            return (
              <EditableUvidCell
                row={row.original}
                field="newPoc"
                label="POC"
                value={editedData[rowId]?.newPoc ?? row.original.newPoc ?? ""}
                onChange={handleCellChange}

              />
            );
          },
        },
        {
          Header: "New VMP",
          id: "newVmp",
          Cell: ({ row }: any) => {
            const rowId = row.original.id;

            return (
              <EditableUvidCell
                row={row.original}
                field="newVmp"
                label="VMP"
                value={editedData[rowId]?.newVmp ?? row.original.newVmp ?? ""}
                onChange={handleCellChange}

              />
            );
          },
        },
        {
          Header: "New IMP",
          id: "newImp",
          Cell: ({ row }: any) => {
            const rowId = row.original.id;

            return (
              <EditableUvidCell
                row={row.original}
                field="newImp"
                label="IMP"
                value={editedData[rowId]?.newImp ?? row.original.newImp ?? ""}
                onChange={handleCellChange}

              />
            );
          },
        },
      ]
      : [];

    return [...baseColumns, ...editableColumns];
  }, [editValue, editedData, handleCellChange]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    selectedFlatRows,

    state: { pageIndex, pageSize, selectedRowIds },
  } = useTable(
    {
      data: flashReports,

      columns,
      defaultColumn,
      initialState: {
        hiddenColumns: ["id", "url", "old_data"],
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header:
            ({ getToggleAllRowsSelectedProps }: HeaderProps<any>) => (
              <div>
                {/* <Checkbox {...getToggleAllRowsSelectedProps()} /> */}
              </div>
            ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }: { row: Row<any> }) => (

            <div>
              {/* {row.values.disposition!="Incorrect value"?<Checkbox {...row.getToggleRowSelectedProps()} />:<></>} */}
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );
  const handleButtonClickClear = () => {
    setPageCount(1)
    setSerialNumber("")
    setprojectNumber("")
    setcustomer("")
    setWorkOrder("")
    setTsdName("")

    setAction(action + 1)
    queryClient.invalidateQueries(['flashData']);
  };

  const handleButtonClick = () => {
    if (serialNumber != "") {
      setPageCount(0)
    } else {
      setPageCount(1)
    }
    setAction(action + 1)
    queryClient.invalidateQueries(['flashData']);
  };
  const [extractedData, setExtractedData] = useState<string[]>([]);

  useEffect(() => {
    const extracted = rows.map((row) => row.values.id);
    setExtractedData(extracted);
  }, [rows]);



  return (
    <>
      {isLoading && (
        <Backdrop open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {isErrorData && <ErrorMessage error={errorData} />}

      {!isLoading && !isErrorData && (
        <>
          <Typography variant="h5">Flash Report</Typography>

          <div style={{ margin: 10, padding: 10 }}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between" // Ensure items are spread across the row
            >

              <Grid item xs={12} container justifyContent="flex-start" alignItems="center" spacing={2}>

                <Grid item xs={3}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Select Filter option</FormLabel>
                    <RadioGroup
                      row
                      aria-label="status"
                      name="status"
                      value={status}
                      onChange={(event, value) => {
                        setStatus(value)

                        if (value == "1") {
                          setSelectedByDate(true)
                          setSelectedByMonth(false)
                          setMonth('')
                        }
                        if (value == "2") {
                          setSelectedByDate(false)
                          setSelectedByMonth(true)

                          setStartDate('')
                          setEndDate('')
                        }
                      }}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="By Date Range" />
                      <FormControlLabel value="2" control={<Radio />} label="By Month" />
                    </RadioGroup>
                  </FormControl>
                </Grid>




                {selectedByDate || selectedByMonth ?
                  <Grid item>
                    <Button
                      variant="outlined" // Outlined button
                      color="primary"
                      onClick={searchData}
                    >
                      Search
                    </Button>
                  </Grid> : null}

                {/* <Grid item xs={3}>
                  <Typography variant="h5">{rows.length ? 'Available :' + rows.length : ""}</Typography>
                </Grid> */}

                {data.results.length ? (

                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={getDownloads}
                    >
                      Download Reports
                    </Button>

                    {/* <Button style={{ marginLeft: '16px' }}
                      variant="contained"
                      color="primary"
                      disabled = {getTheme()}
                      
                      // onClick={getDownloads}
                    >
                      Update Flash Reports
                    </Button> */}


                    <Button style={{ marginLeft: '16px' }}
                      variant="contained"
                      color="primary"
                      disabled={getTheme()}

                      onClick={handleFileUpload}
                    >
                      Corrected Data File Upload
                    </Button>

                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: 'none' }}
                      accept=".xlsx"
                      disabled={getTheme()}

                      onChange={handleFilePicked}
                    />


                    <Button style={{ marginLeft: '16px' }}
                      variant="contained"
                      color="primary"
                      disabled={getTheme()}

                      onClick={() => {
                        setEditValue(true);
                        console.log("Final edited data to submit:", editedData);
                      }}
                    >
                      Update Corrected Data
                    </Button>

                  </Grid>



                ) : null}




              </Grid>





              {selectedByDate && <Grid item xs={4} container justifyContent="flex-start" alignItems="center" spacing={1} style={{ marginTop: 15 }}>
                <Grid item  >

                  <TextField
                    id="start-date"
                    label="Start Date"
                    type="date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    InputLabelProps={{
                      shrink: true, // Keeps the label visible when a value is selected
                    }}
                    variant="outlined" // Adds an outline to the input
                  />
                </Grid>

                <Grid item  >
                  <TextField
                    id="end-date"
                    label="End Date"
                    type="date"
                    value={endDate}
                    onChange={handleEndDateChange}
                    InputLabelProps={{
                      shrink: true, // Keeps the label visible when a value is selected
                    }}
                    variant="outlined" // Adds an outline to the input
                  />
                </Grid>
              </Grid>}

              {selectedByMonth && <Grid item xs={4} style={{ marginTop: 15 }}>
                <Grid item >
                  <TextField
                    id="select_month"
                    label="Select Year and Month"
                    type="month"
                    value={month}
                    onChange={handleChangeDate}
                    InputLabelProps={{
                      shrink: true, // Keeps the label visible when a value is selected
                    }}
                    variant="outlined" // Adds an outline to the input
                  />
                </Grid>
              </Grid>
              }
              {data.results.length ?
                <Grid style={{ marginTop: '16px' }}>

                  <FormControl >
                    <TextField
                      label="Customer"
                      variant="outlined"
                      value={customer}
                      onChange={handleInputChangeCustomer}
                    />
                  </FormControl>

                  <FormControl style={{ marginLeft: '16px' }}  >
                    <TextField
                      label="Project Number"
                      variant="outlined"
                      value={projectNumber}
                      onChange={handleInputChangeProject}
                    />
                  </FormControl>

                  <FormControl style={{ marginLeft: '16px' }}  >
                    <TextField
                      label="Work Order"
                      variant="outlined"
                      value={workorder}
                      onChange={handleInputChangeWorkOrder}
                    />
                  </FormControl>

                  <FormControl style={{ marginLeft: '16px' }}  >
                    <TextField
                      label="Serial number"
                      variant="outlined"
                      value={serialNumber}
                      onChange={handleInputChangeSerial}
                    />
                  </FormControl>

                  <FormControl style={{ marginLeft: '16px' }}  >
                    <TextField
                      label="Tsd"
                      variant="outlined"
                      value={tsdName}
                      onChange={handleInputChangeTsdName}
                    />
                  </FormControl>

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: '16px', marginTop: '10px' }}
                    onClick={handleButtonClick}
                  >
                    Search
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: '16px', marginTop: '10px' }}
                    onClick={handleButtonClickClear}
                  >
                    Clear
                  </Button>



                </Grid>
                : null}



            </Grid>



          </div>
          {data.results.length ?
            <Grid item xs={12}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>

                <Pagination

                  count={Math.ceil(data.count / itemsPerPage)}
                  page={pageCount}
                  onChange={(event, value) => {
                    console.log('Changing page to:', value);
                    setPageCount(value);
                    setAction(action + 1);
                  }}
                  variant="outlined"
                  color="primary"
                />

                <label style={{ marginLeft: '16px' }}>
                  {data.count} results
                </label>
              </div>


            </Grid>
            : null}



          {data.results.length ?
            <div style={{ overflowX: 'auto', width: '100%' }}>

              <LSDBCoreTableWithoutDropDown
                columns={columns}
                data={data.results}
                hiddenColumns={["id", "url", "old_data"]}
              />
            </div>

            :
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
              <Typography variant="h5">No result found</Typography>
            </div>
          }


        </>
      )}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          File Uploaded Successfully!!!
          <IconButton
            aria-label="close"
            onClick={() => setDialogOpen(false)}
            style={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {uploadResult ? (
            <Box>

              <Typography gutterBottom>
                The file was uploaded successfully. A total of {uploadResult.old_measurements_saved} records were corrected and updated.
              </Typography>


            </Box>
          ) : (
            <Typography>Loading result...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

};


export default UvidFeFlash;
